class Node<T>
{
    constructor(value: T)
    {
        this.value = value;
    }

    next: Node<T> | null = null;
    value: T;
}

export class Queue<T>
{
    /** Adds an item to the end of the queue*/
    enqueue(value: T): void
    {
        const newNode = new Node(value);

        if (this.tail)
            this.tail.next = newNode; // Link last node to the new node
        this.tail = newNode; // Update tail pointer

        if (!this.head)
            this.head = newNode; // If queue is empty, point head to new node

        this.size++;
    }

    /** Removes and returns the front item of the queue*/
    dequeue(): T | null
    {
        if (!this.head)
            return null;

        const dequeuedValue = this.head.value;
        this.head = this.head.next; // Move head to next node

        if (!this.head)
            this.tail = null; // If queue is empty, reset tail

        this.size--;
        return dequeuedValue;
    }

    peek(): T | null
    {
        return this.head ? this.head.value : null;
    }

    length(): number
    {
        return this.size;
    }

    isEmpty(): boolean
    {
        return this.size === 0;
    }

    private head: Node<T> | null = null;
    private tail: Node<T> | null = null;
    private size: number = 0;
}
